import Service from "../../AuthService";
const Holiday = {
    getHoliday(page) {
        return Service.get("/holiday?page="+page);
    },
    showHoliday(id) {
        return Service.get("/holiday/" + id);
    },
    updateHoliday(id, data) {
        return Service.put("/holiday/" + id, data);
    },
    createHoliday(data) {
        return Service.post("/holiday", data);
    },
    deleteHoliday(id) {
        return Service.delete("/holiday/" + id);
    },
    searchHoliday(data){
        return Service.post("/holiday_search",data)
    }
};
export default Holiday;
